/**
 * La marque EventMatch.pro — version « projection privée » (Lovable, 2026-08).
 *
 * Deux cercles qui se croisent : le gauche rempli du dégradé signature
 * rose→orange, le droit en simple contour blanc. La rencontre entre l'énergie
 * (le plein, chaud) et l'ouverture (le vide, à remplir) — et l'une des trois
 * seules occurrences autorisées du dégradé dans l'interface.
 */
export function Marque({ taille = 22 }: { taille?: number }) {
  const largeur = Math.round(taille * (34 / 22));
  return (
    <svg
      width={largeur}
      height={taille}
      viewBox="0 0 34 22"
      fill="none"
      role="img"
      aria-label="EventMatch.pro"
    >
      <defs>
        <linearGradient id="marque-degrade" x1="0" y1="0" x2="22" y2="22" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF3D71" />
          <stop offset="1" stopColor="#FF8A3D" />
        </linearGradient>
      </defs>
      <circle cx="11" cy="11" r="10" fill="url(#marque-degrade)" />
      <circle cx="23" cy="11" r="10" stroke="var(--em-texte, #ffffff)" strokeWidth="1.5" fill="transparent" />
    </svg>
  );
}

export function MotMarque() {
  return (
    <span className="mot-marque">
      EventMatch<span className="mot-marque__ext">.pro</span>
    </span>
  );
}
